/**
 * 多条件筛选
 * array 参数 array (数据)
 * filters 参数 obj (筛选条件)
 */
export function multiFilter(array, filters) {
    let filter=filters;
    if(Array.isArray(filters)){
        let param={};
        filters.forEach(v => {
            const key=Object.keys(v)[0];
            param[key]=v[key];
        });  
        filter=param;
    }
    const filterKeys = Object.keys(filter)
    return array.filter((item) => {
        return filterKeys.every(key => {
            if(!filter[key].length) return true
            return !!~filter[key].indexOf(item[key])
        })
    })
}

/**
 * sort方法排序
 * param  参数 array (数据)
 * {} 排序，排序名
 */
export function listSort(param,{order,prop}) {
    return param.sort(function(a,b){                       
        let $a='',$b='';
        if((isFinite(a[prop]) || isFinite(b[prop])) && (a[prop]!=null || a[prop]!=null)){       //避免localeCompare排序问题,对number转换string
            $a=String(a[prop]);
            $b=String(b[prop]);
        }else{
            $a = a[prop] || '';
            $b = b[prop] || '';
        }
        if(order === "ascending"){
            if(!$a){
                return $b.localeCompare($a)     
            }
            return $a.localeCompare($b)
        }else if(order === 'descending'){
            return $b.localeCompare($a)
        }else{
            return param;
        }
    })
}

/**
 * 去重
 * param  参数 array (数据)
 * name   参数  string (要去重的值)
 */
export function removeRepetition(param,name) {
    let hash = {};
    return param.reduce(function(item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
        return item
    }, [])
}
